import type { PickerProps } from 'antd/es/date-picker/generatePicker';
import locale from 'antd/es/date-picker/locale/ru_RU';
import { Controller, useFormContext } from 'react-hook-form';

import { DatePicker } from '../DatePicker/DatePicker';
import { FieldValidationMessage } from '../FieldValidationMessage/FieldValidationMessage';

import styles from './Field.module.scss';

interface IDatePickerProps extends PickerProps {
  fieldName: string;
}

export const DatePickerField = ({ fieldName, ...restProps }: IDatePickerProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field, fieldState: { invalid: isInvalid, error } }) => (
        <div className={styles['field-wrapper']}>
          <DatePicker
            locale={locale}
            {...restProps}
            {...field}
            status={isInvalid ? 'error' : undefined}
          />
          {isInvalid && <FieldValidationMessage message={error?.message} />}
        </div>
      )}
    />
  );
};
